import { z } from 'zod';
import { toolCallsSchema } from '@/entities/chat-message/schema';
import type { ToolCall } from '@/entities/chat-message/types';
import { supabaseClient } from '@/services/api/supabase';

const agentResponseSchema = z.object({
  output: z.object({
    message: z.string(),
    toolCalls: toolCallsSchema.optional().catch(undefined),
  }),
});

interface ClientResponse {
  message: string;
  toolCalls: ToolCall[];
}

export const agentClient = {
  sendToAgent: async (data: unknown): Promise<ClientResponse> => {
    const { data: sessionData } = await supabaseClient.auth.getSession();
    const accessToken = sessionData.session?.access_token ?? '';
    const url = `${import.meta.env.VITE_SUPABASE_URL as string}/functions/v1/ai-agent`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(
        `Agent request failed: ${String(response.status)} ${response.statusText}`,
      );
    }

    const responseData: unknown = await response.json();
    const parsedResponse = agentResponseSchema.parse(responseData);
    return {
      message: parsedResponse.output.message,
      toolCalls: parsedResponse.output.toolCalls ?? [],
    };
  },
};
